import { useRole } from '../../utils/RoleContext';
import getMainRoutes from '../MainRoutes';
import { ProtectRoute } from '../ProtectRoute';

export default function MdRoutes() {
    const { role } = useRole();

    return {
        path: '/',
        element: <ProtectRoute />,
        children: getMainRoutes(role)
    };
}
